import { Content } from "@iventis/translations/content/typed-content";
import React, { FunctionComponent, useMemo } from "react";
import { Node } from "@iventis/domain-model/model/node";
import { Body1, Header2 } from "@iventis/styles/src/components/texts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inlineTextIconMargin } from "@iventis/styles";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { StyledNodeEmptyContainer } from "@iventis/components/src/node-empty";
import { StaticLibrary } from "./mapping-library.helpers";

export const StaticLibraryEmptyComponent: FunctionComponent<{ node: Node; staticLibrary: StaticLibrary }> = ({ node, staticLibrary }) => {
    const translate = useIventisTranslate();
    const title = useMemo(() => translate(Content.library.hints_static_libraries[staticLibrary.translationKey].title), [node.id]);
    const text = useMemo(
        () =>
            // Loop through each paragraph
            Object.values(Content.library.hints_static_libraries[staticLibrary.translationKey])
                // Ignore the first one, as it's the title
                .slice(1)
                .map((text: string) => <Body1 key={text}>{translate(text)}</Body1>),
        [node.id]
    );
    return (
        <StyledNodeEmptyContainer>
            <Header2>
                <span style={{ marginRight: inlineTextIconMargin }}>
                    <FontAwesomeIcon size="sm" icon={["far", staticLibrary.icon]} />
                </span>
                {title}
            </Header2>
            {text}
        </StyledNodeEmptyContainer>
    );
};
